export default __webpack_public_path__ + "static/media/footer-desktop.72000390.png";